/** saves list of notifications preferences
@payload { array }
*/
export const SAVE_NOTIFICATION_PREFERENCES_LIST = (state, data) => {
	state.notificationPreferencesList = data.data.notificationPreferenceViews
}

/** updates notification preference status
@payload { Object } with: notification id (name) and it's allowed status (true or false)
*/
export const UPDATE_NOTIFICATION_STATUS = (state, payload) => {
	const index = state.notificationPreferencesList.findIndex(notification => notification.name === payload.id)

	state.notificationPreferencesList[index].allowed = payload.status
}

/* ***********************************************
*                  CLEAR MUTATIONS               *
*********************************************** */
export const CLEAR_FEATURE_STATE = (state, payload) => {
	state.notificationPreferencesList = []
}
